import { useTeacherStats } from '@/lib/teacher-queries'
import LoadingSpinner from '../LoadingSpinner'

const TeacherStatsCard = () => {
  const { data: stats, isLoading, error } = useTeacherStats()

  if (isLoading) {
    return (
      <div className="card bg-white shadow-xl">
        <div className="card-body flex items-center justify-center min-h-[200px]">
          <LoadingSpinner />
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="card bg-white shadow-xl">
        <div className="card-body">
          <p className="text-error">Failed to load teacher stats</p>
        </div>
      </div>
    )
  }

  return (
    <div className="card bg-white shadow-xl">
      <div className="card-body">
        <h2 className="card-title text-primary">Your Teacher Stats</h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
          <div className="stat bg-base-100 rounded-lg p-4">
            <div className="stat-title">Points to Distribute</div>
            <div className="stat-value text-primary text-3xl">
              {stats?.points_to_distribute?.toFixed(0) || 0}
            </div>
            <div className="stat-desc">Available for students</div>
          </div>

          <div className="stat bg-base-100 rounded-lg p-4">
            <div className="stat-title">Total Points Given</div>
            <div className="stat-value text-secondary text-3xl">
              {stats?.total_given?.toFixed(0) || 0}
            </div>
            <div className="stat-desc">All time</div>
          </div>

          <div className="stat bg-base-100 rounded-lg p-4">
            <div className="stat-title">Students Helped</div>
            <div className="stat-value text-accent text-3xl">
              {stats?.students_helped || 0}
            </div>
            <div className="stat-desc">Unique students</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TeacherStatsCard
